<ng-template #uploadModalFormSearch role="document" let-modal>
  
  <app-modal-comp-header
    [title]="formTitle"
    (cancelButtonOnClick)="searchFormCancel()"
  ></app-modal-comp-header>
  
  <form (ngSubmit)="searchFormSubmit()" [formGroup]="searchForm" class="tablelist-form" autocomplete="off">
    <div class="modal-body">

      <div class="row">
        <div class="col-12">
          <div class="mb-1">
            <label class="form-label text-right"></label>
            <div class="alert border-0 {{alertColourProgress}}" role="alert">
              <strong>Information</strong> - <span [innerHtml]="progressInformation" ></span>
            </div>
          </div>
        </div>
      </div>
      <!--
      <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <div class="border border-success rounded">
              <div class="row">
                <div class="col-12">
                  <div>
                    <div class="alert border-0 alert-primary" role="alert">
                      <strong></strong>
                    </div>
                  </div>
                </div>
              </div>
                                          
            </div>
          </div>
        </div>
      </div>
      -->
      <div class="row">
        <div class="col-12">
          <div class="border border-success rounded">
            <div class="row">
              <div class="col-12">
                <div>
                  <div class="alert border-0 alert-primary" role="alert">
                    <strong>Available Files</strong>
                  </div>
                </div>
              </div>
            </div>
                                        
            <div class="row">
              <div class="col-12">
                <div class="px-2">
                  <app-downloadable-files-embedded
                    (gridRowClick)="gridRowClick($event)"
                    (gridRowDblClick)="gridRowDblClick($event)"
                  ></app-downloadable-files-embedded>
                </div>
              </div>
            </div>
                      
          </div>
        </div>
      </div>

    </div>
    <div class="modal-footer">
      <div class="hstack gap-2 justify-content-end">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="searchFormCancel()">Close</button>
        <button type="submit" class="btn btn-success" id="add-btn">Submit</button>
      </div>
    </div>
  </form>    
</ng-template>

<app-warning-modal-form #warningModalForm
></app-warning-modal-form>
